import google from "../../../assets/images/google-icon.png";
import home_banner2 from "../../../assets/images/signup_img.jpg";
import { useEffect, useState } from "react";
import { alertActions } from "../../../actions/alert.actions";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { UserService } from "../../../services";

const useForgotPasswordHook = () => {
  let history = useNavigate();
  const [mobile, setMobile] = useState("");
  const dispatch = useDispatch();
  const [submitted, setSubmitted] = useState(false);
  const [forgotPasswordData, setForgotPasswordData] = useState({});
  const [forgotPasswordError, setForgotPasswordError] = useState("");

  useEffect(() => {
    if (forgotPasswordData?.data?.status?.code === 0) {
      history("/getOtp", {
        state: { mobile: mobile },
      });

      setMobile("");

      setSubmitted(false);
      setTimeout(() => {
        dispatch(
          alertActions.success(forgotPasswordData?.data?.status?.message)
        );
      }, 50);
    } else {
      setForgotPasswordError(forgotPasswordData?.data?.status?.message);
      //dispatch(alertActions.error(forgotPasswordData?.data?.status?.message));
    }
  }, [forgotPasswordData]);
  function handleChange(e) {
    setForgotPasswordError(undefined);
    setMobile(e.target.value);
  }
  function handleSubmit(e) {
    e.preventDefault();
    setSubmitted(true);
    var filter = /^[0-9]{10}$/;
    if (mobile) {
      if (!filter.test(mobile)) {
        setForgotPasswordError("Enter valid Mobile Number");
        //dispatch(alertActions.error("Enter valid Mobile Number"));
      } else {
        UserService.forgotPassword(mobile)
          .then((response) => {
            setForgotPasswordData(response);
          })
          .catch((error) => {
            console.log("Errorreg", error);
          });
      }
    }
  }

  return {
    google,
    home_banner2,
    mobile,
    submitted,
    forgotPasswordError,
    handleChange,
    handleSubmit,
  };
};
export default useForgotPasswordHook;
